import { render, staticRenderFns } from "./RootApp.vue?vue&type=template&id=2e7679e6"
import script from "./RootApp.vue?vue&type=script&lang=ts"
export * from "./RootApp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports